
export const planDescription: any = {
  free: 'Get started scanning Squarespace pages now',
  diy: 'Essential SEO tools for individuals and small projects',
  starter: 'Essential SEO tools for individuals and small projects',
  starterplus: 'Essential SEO tools for individuals and small projects',
  designer: 'For pros who want to beat the competition on search engines',
  proplus: 'For pros who want to beat the competition on search engines',
  agency: 'Advanced SEO tools for businesses owners and web designers',
  expertplus: 'Advanced SEO tools for businesses owners and web designers'
};

export const tabIndices: Record<string, number> = {
  Free: 0,
  DIY: 1,
  Designer: 2,
  Agency: 3
};

export const defaultTabStyle = {
  background: 'transparent',
  border: 0,
  color: 'var(--color-text-mid)',
  cursor: 'pointer',
  borderRadius: '300px',
  padding: '4px 8px',
  width: 'min-content',
  minWidth: '70px',
  fontWeight: 500
};

export const selectedTabStyle = {
  ...defaultTabStyle,
  background: 'var(--color-primary)',
  color: 'var(--color-white)'
};

export const cardSubTextStyles = {
  fontSize: '14px',
  fontWeight: '600',
  marginBottom: '0.2rem'
};

export const resellerFeatures = [
  { title: 'Websites', value: '∞' },
  { title: 'Unlimited Client Sites', value: true },
  { title: 'Full White-Label Platform', value: true },
  { title: 'Reseller Dashboard', value: true },
  { title: 'AI Credits (Unlimited)', value: true },
  { title: 'Bulk Reporting & Exports', value: true },
  { title: 'Client Management Portal', value: true },
  { title: 'API Access', value: true },
  { title: 'Dedicated Success Manager', value: true },
  { title: 'Custom Onboarding Training', value: true },
  { title: 'Priority 24/7 Support', value: true }
];

export const resellerCard = (selectedValue: string) => ({
  title: 'Reseller',
  subText:
    'Built for agencies and web designers managing multiple client sites at scale',
  amount: 'Custom',
  btnText: 'Schedule A Call',
  isActivePlan: false,
  metadata: { display_name: 'Reseller' },
  recurring: { interval: selectedValue === 'annually' ? 'year' : 'month' }
});
